import { useSvg } from "@faro-lotv/app-component-toolbox";
import { Texture } from "three";
import FlashDefaultSvg from "./VM_ScanMarkerFlash.svg?url";
import FlashHoveredSvg from "./VM_ScanMarkerFlash_hovered.svg?url";

export type FlashScanIcons = {
  /** Texture representing the default flash scan icon */
  flashDefault: Texture | undefined;
  /** Texture representing the hovered flash scan icon */
  flashHovered: Texture | undefined;
};

const colorsToReplace = {
  "#1F65F0": "red",
  "#082A6E": "red",
};

/**
 *
 * @returns Textures to use to represent flash scan waypoints
 */
export function useFlashScanIcons(): FlashScanIcons {
  const flashDefault = useSvg(FlashDefaultSvg, {
    width: 256,
    height: 256,
    generateMipmaps: true,
    colorsToReplace,
  });
  const flashHovered = useSvg(FlashHoveredSvg, {
    width: 256,
    height: 256,
    generateMipmaps: true,
    colorsToReplace,
  });

  return {
    flashDefault,
    flashHovered,
  };
}
